module.exports = __webpack_public_path__ + "static/logo-ai2-white-withText-b4744b7c99fa63d27b9c1b7634a654f2.svg";